import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isFlightsDirtySelector, isFlightsValidatedSelector, flightsFormsSelector, } from '@/models/flights/selectors';
import { flightsActions } from '@/models/flights';
import { validateFlights } from '@/models/flights/validateFlights';
import { goNextStep } from '@/models/steps/goNextStep';
import { FLIGHTS_CONTAINER_ID } from '../Forms/Flight/Flights';
import { Flights } from '../Forms/Flight/Flights';
import { useInsuranceStyles } from '../styles';
import { ContinueButton } from '../ContinueButton';
import { UserAgreementBlock } from '../UserAgreementBlock';
export const FlightsTab = () => {
    const insuranceClasses = useInsuranceStyles();
    const dispatch = useDispatch();
    const routerLocation = useLocation();
    const locationState = routerLocation.state;
    const isFlightsValidated = useSelector(isFlightsValidatedSelector);
    const isFlightsDirty = useSelector(isFlightsDirtySelector);
    const flights = useSelector(flightsFormsSelector);
    useEffect(() => {
        dispatch(validateFlights());
    }, [flights]);
    useEffect(() => {
        if (locationState === FLIGHTS_CONTAINER_ID) {
            const containerRef = document.getElementById(locationState);
            containerRef?.scrollIntoView({ behavior: 'smooth' });
            routerLocation.state = null;
        }
    }, [locationState]);
    const onContinue = useCallback(() => {
        dispatch(flightsActions.setFlightsDirty());
        dispatch(flightsActions.setAllFlightsFieldsDirty());
        if (!isFlightsValidated) {
            return;
        }
        dispatch(goNextStep());
    }, [isFlightsValidated]);
    return (_jsxs(_Fragment, { children: [_jsx(Flights, {}), _jsx("div", { className: insuranceClasses.buttons, children: _jsx(ContinueButton, { onClick: onContinue, isDisabled: isFlightsDirty && !isFlightsValidated }) }), _jsx(UserAgreementBlock, {})] }));
};
export default FlightsTab;
